import { RapidSOSMark } from '@/components/RapidSOSMark/RapidSOSMark';
import { RapidSOSWordmark } from '@/components/RapidSOSMark/RapidSOSWordmark';
import { DEFAULT_MARK_ANIMATION } from '@/components/RapidSOSMark/animations';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';

export function SignInPage() {
  const { loginWithRedirect } = useAuth();

  return (
    <div className="flex h-full items-center justify-center bg-background">
      <div className="flex w-full max-w-sm flex-col items-center gap-6 rounded-2xl border border-border bg-card px-8 py-10 shadow-sm">
        <div className="flex items-center gap-2 text-foreground">
          <RapidSOSMark className="h-8 w-8" animation={DEFAULT_MARK_ANIMATION} />
          <RapidSOSWordmark className="h-8" />
        </div>
        <div className="text-center">
          <h1 className="text-xl font-semibold text-foreground">Studio Admin</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Sign in with a platform-admin account to manage organizations, billing, and usage.
          </p>
        </div>
        <Button type="button" className="w-full" onClick={() => loginWithRedirect()}>
          Sign in
        </Button>
      </div>
    </div>
  );
}
